import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
import { Animate } from 'react-simple-animate';

export default class CustomerJobBulkUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCustomerId: null,
      selectedCustomer: null,
      selectedOption: null,
      isCustomerLogin: !!props.isCustomerLogin,
      loggedIncustomer: props.loggedIncustomer ? JSON.parse(props.loggedIncustomer) : {},
      jobId: null,
      play: true,
      isLoading: false,
    }
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    this.handleImportCustomerJobs = this.handleImportCustomerJobs.bind(this);
  }
  componentDidMount() {
    if(this.state.isCustomerLogin){
      this.handleCustomerSelection(this.state.loggedIncustomer);
    }
    if(this.state.selectedCustomerId){
      this.handleCustomerSelection(this.state.selectedCustomerId);
    }
  }
  handleCustomerSelection(option) {
    if (option) {
      this.setState({
        selectedOption: option,
        selectedCustomer: option,
        selectedCustomerId: option.id
      });
    }
  }
  handleImportCustomerJobs(e) {
    this.setState({isLoading:true});
    const input = document.getElementById('bulk_upload_customer_jobs');
    let file = input.files[0];
    const data = new FormData();
    data.append('bulk_upload_customer_jobs',file,file.name );
    data.append('customer_id', this.state.selectedCustomerId);
    return fetch(
      '/api/v1/portal/customers/bulk-import-customer-jobs',
      {
        method: 'POST',
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          ,"Accept": 'application/json'
        },
        body: data,
      }).then((responseText) => {
          let response = responseText.json();
          this.setState({isLoading:false});
          response.then((response) => {
            $('#infomodallabel').html('Success');
            $('#infomodal .modal-body').html(response);
            $('#infomodal').modal();
          });
      }).catch((error) => {
        this.setState({isLoading:false});
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html(error);
          $('#infomodal').modal();
        }
      );
  }
  render() {
    let customerId = this.state.selectedCustomerId;
    return (
      <Animate
        play={this.state.play}
        start={{opacity: 0}}
        end={{opacity: 1}}
      >
      <form id="add_new_job_form" ref="addNewJobForm">
        <fieldset>
          <div id="place-service-helper-div"></div>
            <div className="row">
              <div className="col-md-6">
                <h2>Import Customer Jobs</h2>
                <br />
                <br />
              </div>
            </div>
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <h3>Customer</h3>
              {this.state.isCustomerLogin ? 
                <select className="form-control form-control-lg" name="customer_id" readOnly={true} value={this.state.loggedIncustomer.id}>
                  <option key={'customer-'+this.state.loggedIncustomer.id} value={this.state.loggedIncustomer.id}>{this.state.loggedIncustomer.name}</option>
                </select>
              :
                <CustomersPowerSelect
                  handleCustomerSelection={this.handleCustomerSelection}
                  jobId={this.state.jobId}
                  selected={this.state.selectedOption}
                  selectedOption={this.state.selectedOption}
                  selectedCustomer={this.state.selectedCustomer}
                  selectedCustomerId={customerId}
                 />
              }
            </div>
          </div>
            <div className='row'>
              <div className="container-fluid">
                <div className="row col-md-6 mt-5 subsection-container">
                  <div className="col-md-4">
                    <input
                      type="file"
                      name="bulk_upload_customer_jobs"
                      id="bulk_upload_customer_jobs"
                    />
                  </div>
                  <div className="col-md-6 text-center">
                    <button
                      className="btn btn-lg btn-primary"
                      disabled={(this.state.isLoading) ? true : false}
                      onClick={(e) => {
                        this.handleImportCustomerJobs(e);
                      }}
                    >
                      <i className="fa fa-upload"></i>&nbsp;
                      Upload & Import Customer Jobs
                    </button>
                  </div>
                  <br />
                  <br />
                  <div className="col-md-12">
                    <small>Download <a href="/import/import-customer-jobs.csv" download> sample file from here.</a></small>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
            </div>
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </fieldset>
      </form>
      </Animate>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-customer-job-bulk-upload')) {
    let customerId = document.getElementById('react-component-g4-logistics-portal-customer-job-bulk-upload').getAttribute('data-customer-id');
    let customer = document.getElementById('react-component-g4-logistics-portal-customer-job-bulk-upload').getAttribute('data-customer');
  ReactDOM.render(<CustomerJobBulkUpload isCustomerLogin={customerId} loggedIncustomer={customer}/>,
    document.getElementById(
      'react-component-g4-logistics-portal-customer-job-bulk-upload')
  );
}
